import React from "react";
import SummaryDetailsCard from "../../../../../../components/Summary/SummaryDetailsCard";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Details container for the work shift summary. Shows the work shift name.
 */
const SummaryContainerDetails = ({ data, t }) => {

    const items = [
        {
            label: 'name',
            value: data?.name
        }
    ];

    return <SummaryDetailsCard items={items} t={t} className={'d-block'} />;

}

export default SummaryContainerDetails
